import { render, staticRenderFns } from "./EomItems.vue?vue&type=template&id=72ec631f&scoped=true&"
import script from "./EomItems.vue?vue&type=script&lang=js&"
export * from "./EomItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec631f",
  null
  
)

export default component.exports